export const BadgeNumber = (type) => ({
  init() {
    this.typeName = `${type}Count`
    this.initCount = this.$el.dataset.initBadgeNumber
    this.$store.frontend[this.typeName] = this.initCount
  },

  get show() {
    return this.$store.frontend[this.typeName] && this.$store.frontend[this.typeName] > 0
  },

  get count() {
    if (this.$store.frontend[this.typeName] > 9) {
      return "9+"
    }

    return this.$store.frontend[this.typeName]
  },
})
